import PropTypes from 'prop-types';
import { Typography, Box } from '@mui/material';
import { formatDate } from '../../../utils';

const Item = ({ label, value }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      '& :first-child': {
        marginRight: '5px',
      },
    }}
  >
    <Typography variant="body2" component="span">
      {label}:
    </Typography>
    <Typography variant="body2" component="span">
      {value}
    </Typography>
  </Box>
);

const Request = ({ isOpen, data }) => {
  if (!isOpen) {
    return null;
  }

  const requestedAt = formatDate(data.requestedAt, 'MMM do yy');

  let startDate = '';
  let endDate = '';
  if (data.for === 'vacation') {
    startDate = formatDate(data.vacationFrom, 'MMM do yy');
    endDate = formatDate(data.vacationTo, 'MMM do yy');
  }

  return (
    <Box sx={{ width: '100%', paddingTop: '5px', borderTop: '1px solid rgba(0, 0, 0, 0.1)' }}>
      <Item value={requestedAt} label="Requested at" />

      {data.for === 'vacation' && (
        <>
          <Item value={`${startDate} - ${endDate}`} label="From-to" />
          <Item value={data.noOfDays} label="Duration" />
        </>
      )}
    </Box>
  );
};

Request.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  data: PropTypes.object,
};

Request.defaultProps = {
  data: {},
};

Item.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
};

export default Request;
